import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

function getAnnualReportsQuery(opts: RequestOpts = {}) {
  const queryKey = ['getAnnualReports'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return api.getEdrmsdocumentAnnualreports({ ...opts, signal });
    },
    staleTime: ms('5m'),
    gcTime: ms('10m'),
  });
}

export async function fetchAnnualReportsQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getAnnualReportsQuery(opts));
}
